import { Dispatch } from 'react';
import { TMaintenancePackageActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { DELETE_MAINTENANCE_PACKAGE } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';

export const deleteMaintenancePackageById = async (
    dispatch: Dispatch<TMaintenancePackageActionTypes>,
    maintenancePackageId: string
): Promise<string | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.delete(
            `/maintenance-packages/${maintenancePackageId}/delete`,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: DELETE_MAINTENANCE_PACKAGE,
            payload: null,
        });

        return res.data.data.deletedId;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
